import { async } from 'regenerator-runtime';
import {
  req,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
  getSettingsData,
} from '../js/config';
import {
  cottageData,
  pipestringToList,
  createDateFromDateString,
} from '../js/base';
//import { async } from "regenerator-runtime";
let PageData = {};
let CottageData = {};
let SleepingArrangements = {};
let CottageSettings = {};

const Initialize = async () => {
  try {
    //const queryData = await readQueryString(window.location.href);
    //console.log("🚀 ~ file: main.js:13 ~ Initialize ~ queryData:", queryData)

    await getPageData();
    try {
      updateMetaTags(CottageData.attributes.name);
    } catch {}

    // Convert the date strings to Date objects for easy comparison
    CottageData.attributes.calendar.bookings.forEach(function (range) {
      // Split the date string and create a new Date object
      var fromDateParts = range.fromDate.split('-');
      var toDateParts = range.toDate.split('-');

      // Adjust month value (-1) because JavaScript months start at 0
      range.fromDate = new Date(
        fromDateParts[0],
        fromDateParts[1] - 1,
        fromDateParts[2]
      )
        .toISOString()
        .split('T')[0];
      range.toDate = new Date(
        toDateParts[0],
        toDateParts[1] - 1,
        toDateParts[2]
      )
        .toISOString()
        .split('T')[0];
    });

    function isDateBooked(date) {
      return CottageData.attributes.calendar.bookings.some(function (range) {
        var startDate = parseDateAsLocal(range.fromDate);
        var endDate = parseDateAsLocal(range.toDate);

        // Set startDate to the start of the next day after the booking starts
        // startDate.setDate(startDate.getDate() + 1);
        //startDate.setHours(0, 0, 0, 0);

        // Set endDate to the start of the day the booking ends
        endDate.setHours(0, 0, 0, 0);

        // Check if the date falls within the booking range, excluding the start and end dates
        return date >= startDate && date < endDate;
      });
    }

    function parseDateAsLocal(dateString) {
      const [year, month, day] = dateString
        .split('-')
        .map((part) => parseInt(part, 10));
      return new Date(year, month - 1, day); // Month is 0-indexed
    }

    $('#datepicker1')
      .datepicker({
        format: 'dd-mm-yyyy',
        autoclose: true,
        beforeShowDay: function (date) {
          var month = date.getMonth();

          // Check if date is within the booked range
          if (isDateBooked(date)) {
            return false;
          }

          if (
            month >= CottageSettings.weeklyBookingMonthStart &&
            month <= CottageSettings.weeklyBookingMonthEnd
          ) {
            // months are 0-based
            return date.getDay() == CottageSettings.defaultCheckinDay; // if Saturday
          }

          return true;
        },
      })
      .on('changeDate', function (selected) {
        var selectedDate = new Date(selected.date.valueOf())
          .toISOString()
          .split('T')[0];
        console.log('🚀 ~ selectedDate:', selectedDate);
        var minDate = new Date(selected.date.valueOf());
        var selectedMonth = selected.date.getMonth();

        // Adjust the minimum days based on the month
        if (
          selectedMonth >= CottageSettings.weeklyBookingMonthStart &&
          selectedMonth <= CottageSettings.weeklyBookingMonthEnd
        ) {
          minDate.setDate(minDate.getDate() + 7); // Set for weekly booking
        } else {
          minDate.setDate(
            minDate.getDate() + parseInt(CottageSettings.minimumBookingDays)
          );
        }

        console.log('🚀 ~ minDate:', minDate);

        // Find the next booked date after the selected date
        var nextBookedDate = null;
        for (
          var i = 0;
          i < CottageData.attributes.calendar.bookings.length;
          i++
        ) {
          var booking = CottageData.attributes.calendar.bookings[i];
          var bookingStart = new Date(booking.fromDate)
            .toISOString()
            .split('T')[0];
          console.log('🚀 ~ bookingStart:', bookingStart);

          if (bookingStart > selectedDate) {
            if (!nextBookedDate || bookingStart < nextBookedDate) {
              nextBookedDate = bookingStart;
            }
          }
        }
        console.log('🚀 ~ nextBookedDate:', nextBookedDate);

        // If there's a next booked date, adjust minDate and maxDate
        var maxDate;
        if (nextBookedDate) {
          maxDate = createDateFromDateString(nextBookedDate);
          console.log('🚀 ~ maxDate:', maxDate);
          maxDate.setDate(maxDate.getDate()); // Last available day is the day  the next booking starts
        } else {
          // Set maxDate based on CottageSettings if there's no next booking
          maxDate = new Date(selected.date.valueOf());
          console.log('🚀 ~ maxDate else:', maxDate);
          console.log('🚀 ~ maxDate else:', maxDate);
          var selectedMonth = selected.date.getMonth();
          if (
            selectedMonth >= CottageSettings.weeklyBookingMonthStart &&
            selectedMonth <= CottageSettings.weeklyBookingMonthEnd
          ) {
            maxDate.setDate(maxDate.getDate() + 7);
          } else {
            maxDate.setDate(maxDate.getDate() + 14);
          }
        }

        $('#datepicker2').datepicker('setStartDate', minDate);
        $('#datepicker2').datepicker('setEndDate', maxDate);
        $('#datepicker2').datepicker('update', minDate);
      });

    $('#datepicker2').datepicker({
      format: 'dd-mm-yyyy',
      autoclose: true,
      beforeShowDay: function (date) {
        var month = date.getMonth();
        var isStartDateOfBooking = false;

        // Check if the date is the start date of any booking
        CottageData.attributes.calendar.bookings.forEach(function (booking) {
          var bookingStartDate = parseDateAsLocal(booking.fromDate);
          if (areDatesEqual(bookingStartDate, date)) {
            isStartDateOfBooking = true;
          }
        });

        // Allow selection of the start date of bookings (for check-out)
        if (isStartDateOfBooking) {
          return true;
        }

        // Check if date is within the booked range
        if (isDateBooked(date)) {
          return false;
        }

        // Check if it's the valid check-in day in the booking months
        if (
          month >= CottageSettings.weeklyBookingMonthStart &&
          month <= CottageSettings.weeklyBookingMonthEnd
        ) {
          return date.getDay() === CottageSettings.defaultCheckinDay; // if Saturday
        }

        return true;
      },
    });

    function areDatesEqual(date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    }

    await generatePageHTML();

    await bindPageControls();

    await loadJavascriptNow();

    var loader = document.getElementById('loader-wrapper');
    loader.style.display = 'none';
  } catch (err) {
    var loader = document.getElementById('loader-wrapper');
    loader.style.display = 'none';
    console.log('🚀 ~ file: main.js:14 ~ Initialize ~ err', err);
  }
};

const readQueryString = async (url) => {
  const paramArr = url.slice(url.indexOf('?') + 1).split('&');
  const params = {};
  paramArr.map((param) => {
    const [key, val] = param.split('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
};

const generatePageHTML = async () => {
  await CottageTitle();
  await CottageGallery();
  await CottagePrice();
  await CottageOverview();
  await CottageAmenities();
};

const bindPageControls = async () => {
  console.log('bind function called.');

  const bookingDetailsBtn = document.getElementById('bookingDetails');

  bookingDetailsBtn.addEventListener('click', function () {
    const arrivalDate = document
      .getElementById('input_arrivalDate')
      .value.trim();
    const departureDate = document
      .getElementById('input_departureDate')
      .value.trim();
    const noOfAdults = document.getElementById('input_noOfAdults').value.trim();
    const noOfChildren = document
      .getElementById('input_noOfChildren')
      .value.trim();

    let focusField = null;
    if (!arrivalDate) {
      focusField = document.getElementById('input_arrivalDate');
    } else if (!departureDate) {
      focusField = document.getElementById('input_departureDate');
    } else if (!noOfAdults) {
      focusField = document.getElementById('input_noOfAdults');
    } else if (!noOfChildren) {
      focusField = document.getElementById('input_noOfChildren');
    }

    if (focusField) {
      alert('Please fill in all the fields.');
      focusField.focus();
    } else {
      const arrivalDateParts = arrivalDate.split('-');
      const departureDateParts = departureDate.split('-');
      const arrivalDateObj = new Date(
        `${arrivalDateParts[1]}/${arrivalDateParts[0]}/${arrivalDateParts[2]}`
      );
      const departureDateObj = new Date(
        `${departureDateParts[1]}/${departureDateParts[0]}/${departureDateParts[2]}`
      );
      console.log('🚀 ~ file: main.js:79 ~ arrivalDateObj:', arrivalDateObj);

      console.log(
        '🚀 ~ file: main.js:80 ~ departureDateObj:',
        departureDateObj
      );
      if (
        departureDateObj.getFullYear() < arrivalDateObj.getFullYear() ||
        (departureDateObj.getFullYear() === arrivalDateObj.getFullYear() &&
          departureDateObj.getMonth() < arrivalDateObj.getMonth()) ||
        (departureDateObj.getFullYear() === arrivalDateObj.getFullYear() &&
          departureDateObj.getMonth() === arrivalDateObj.getMonth() &&
          departureDateObj.getDate() <= arrivalDateObj.getDate())
      ) {
        alert('Departure date must be greater than arrival date.');
        document.getElementById('input_departureDate').focus();
      } else {
        const url = `../booking.html?cottageId=${
          CottageData.attributes.cottageId
        }&arrivalDate=${convertDateFormat(
          arrivalDate
        )}&departureDate=${convertDateFormat(
          departureDate
        )}&noOfAdults=${noOfAdults}&noOfChildren=${noOfChildren}`;
        window.location.href = url;
        //alert('redirect')
      }
    }
  });
};

const CottageTitle = async () => {
  let tpl = '';

  console.log(
    '🚀 ~ file: main.js:104 ~ CottageTitle ~ CottageData:',
    CottageData
  );

  tpl += ` <h2>${CottageData.attributes.name}</h2>`;

  document.querySelector('#CottageTitle').innerHTML = tpl;
};
const CottageGallery = async () => {
  let tpl = '';

  CottageData.attributes.images.data.forEach((e) => {
    const imageUrl = e.attributes.formats.small
      ? `https://api.yootechnologies.com${e.attributes.formats.small.url}`
      : `https://api.yootechnologies.com${e.attributes.url}`;
    const imageAlt = e.attributes.name;

    tpl += `  <div class="gallery__img-block  ">
        <img src="${imageUrl}" alt="${imageUrl}" class="">
    </div>`;
  });
  document.querySelector('#CottageGallery').innerHTML = tpl;
};

const CottagePrice = async () => {
  let tpl = '';

  tpl += `  <span class="amout">$${CottageData.attributes.rate}</span> /Night`;

  document.querySelector('#CottagePrice').innerHTML = tpl;
};
const CottageOverview = async () => {
  SleepingArrangements = await pipestringToList(
    CottageData.attributes.overview.SleepingArrangements
  );

  let tpl = '';

  tpl += `     <div class="product-detail_overview">
    <h5 class='text-uppercase'>${CottageData.attributes.name}</h5>
    <p>${CottageData.attributes.overview.Description}</p>
    <div class="row">
        <div class="col-xs-6 col-md-4">
        <h6>FEATURES</h6>
            <ul>
            <li>Guests: ${CottageData.attributes.overview.Guests}</li>
                  <li>Baths: ${CottageData.attributes.overview.Baths}</li>
                  <li>Bedrooms: ${CottageData.attributes.overview.Bedrooms}</li>
                  <li>Beds: ${CottageData.attributes.overview.Beds}</li>
            </ul>
        </div>
        <div class="col-xs-6 col-md-4">
        <h6>Sleeping Arrangements</h6>
            <ul id="list_sleepingArrangements">

            ${await listSleepingArrangements()}
            </ul>
        </div>
    </div>
</div>`;

  document.querySelector('#overview').innerHTML = tpl;
};

const listSleepingArrangements = async () => {
  let tmp = '';
  SleepingArrangements.forEach((r) => {
    tmp += `     <li> ${r}</li>`;
  });

  return tmp;
};
const CottageAmenities = async () => {
  let tpl = '';

  console.log(
    '🚀 ~ file: main.js:152 ~ CottageAmenities ~  CottageData.attributes.amenities',
    CottageData.attributes.amenities
  );
  tpl += `    <div class="product-detail_amenities">
        ${await CottageAmenitiesHeading(CottageData.attributes.amenities)}
                    </div>`;

  document.querySelector('#amenities').innerHTML = tpl;
};

const CottageAmenitiesHeading = async (d) => {
  let utpl = '<div class="row">'; // Start the row

  if (d.Bathroom != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Bathroom</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(d.Bathroom)}
                        </ul>
                    </div> 
                `;
  }
  if (d.ScenicViews != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Scenic Views</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.ScenicViews
                            )}
                        </ul>
                    </div> 
                `;
  }
  if (d.Bathroom != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Bathroom</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(d.Bathroom)}
                        </ul>
                    </div> 
                `;
  }
  if (d.HeatingAndCooling != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Heating and Cooling</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.HeatingAndCooling
                            )}
                        </ul>
                    </div> 
                `;
  }
  if (d.HomeSafety != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Home Safety</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(d.HomeSafety)}
                        </ul>
                    </div> 
                `;
  }
  if (d.InternetAndOffice != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Internet and Office</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.InternetAndOffice
                            )}
                        </ul>
                    </div> 
                `;
  }

  if (d.LocationFeatures != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Location Features</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.LocationFeatures
                            )}
                        </ul>
                    </div> 
                `;
  }
  if (d.Outdoor != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Outdoor</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(d.Outdoor)}
                        </ul>
                    </div> 
                `;
  }
  if (d.ParkingAndFacilities != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Parking and Facilities</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.ParkingAndFacilities
                            )}
                        </ul>
                    </div> 
                `;
  }
  if (d.Services != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Services</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(d.Services)}
                        </ul>
                    </div> 
                `;
  }

  if (d.KitchenAndDining != '') {
    utpl += `
                    <div class="col-xs-6 col-lg-4"> 
                        <h6>Kitchen and Dining</h6>
                        <ul>
                            ${await CottageAmenitiesHeadingDetail(
                              d.KitchenAndDining
                            )}
                        </ul>
                    </div> 
                `;
  }
  utpl += '</div>'; // Close the row
  return utpl;
};

const CottageAmenitiesHeadingDetail = async (i) => {
  let ltpl = '';
  let listItems = pipestringToList(i);

  listItems.forEach((x) => {
    ltpl += `                      
        <li>${x}</li>
        
`;
  });

  return ltpl;
};

const getPageData = async () => {
  PageData = window.__COTTAGE_DATA__;

  CottageData = PageData.Result;
  // CottageData = PageData.filter((s) => s.id == id);

  CottageSettings = await getSettingsData();
  console.log(
    '🚀 ~ file: main.js:305 ~ getPageData ~ CottageSettings:',
    CottageSettings
  );

  console.log(CottageData);
};

const convertDateFormat = (inputDate) => {
  // Split the input string on dash character
  var splitDate = inputDate.split('-');

  // Assemble and return the date in 'yyyy-mm-dd' format
  return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
};

const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = '../js/sky.js';

  // Append to the `head` element
  document.head.appendChild(script);
};

// Function to update SEO and social media meta tags
function updateMetaTags(cottageNumber) {
  // Update the title
  document.title = `PickWick Cottages : Detailed View of Cottage ${cottageNumber} in Sauble Beach, Ontario`;

  // Function to set or update meta tags
  const setMetaTag = (name, content) => {
    let element =
      document.querySelector(`meta[name='${name}']`) ||
      document.createElement('meta');
    element.name = name;
    element.content = content;
    document.getElementsByTagName('head')[0].appendChild(element);
  };

  // Function to set or update Open Graph meta tags for Facebook
  const setOGTag = (property, content) => {
    let element =
      document.querySelector(`meta[property='og:${property}']`) ||
      document.createElement('meta');
    element.setAttribute('property', `og:${property}`);
    element.content = content;
    document.getElementsByTagName('head')[0].appendChild(element);
  };

  // Update meta tags
  setMetaTag(
    'description',
    `Explore Cottage ${cottageNumber} offered by PickWick Cottages in Sauble Beach, Ontario. View detailed amenities, images, and pricing to plan your ideal vacation stay!`
  );
  setMetaTag(
    'keywords',
    `PickWick Cottages, Cottage ${cottageNumber}, Sauble Beach, Ontario, beachside cottage, vacation rental, detailed view`
  );

  // Update Open Graph tags for Facebook
  setOGTag(
    'title',
    `PickWick Cottages: Detailed View of Cottage ${cottageNumber} in Sauble Beach, Ontario`
  );
  setOGTag(
    'description',
    `Explore Cottage ${cottageNumber} offered by PickWick Cottages in Sauble Beach, Ontario. View detailed amenities, images, and pricing to plan your ideal vacation stay!`
  );
  setOGTag(
    'image',
    'https://api.yootechnologies.com${CottageData.attributes.images.data[0].attributes.url}'
  );
  setOGTag('url', window.location.href);

  // Update Twitter tags
  setMetaTag('twitter:card', 'summary_large_image');
  setMetaTag(
    'twitter:title',
    `PickWick Cottages: Detailed View of Cottage ${cottageNumber} in Sauble Beach, Ontario`
  );
  setMetaTag(
    'twitter:description',
    `Explore Cottage ${cottageNumber} offered by PickWick Cottages in Sauble Beach, Ontario. View detailed amenities, images, and pricing to plan your ideal vacation stay!`
  );
  setMetaTag(
    'twitter:image',
    `https://api.yootechnologies.com${CottageData.attributes.images.data[0].attributes.url}`
  ); // Replace with the actual image URL
}

// Retrieve the cottage number from the URL (assuming it's the last segment)
const urlSegments = window.location.pathname.split('/');
const cottageNumber = urlSegments[urlSegments.length - 1];

// Update the meta tags based on the cottage number

Initialize();
